import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { AuthService } from './auth.service';
// import { AuthenticationService } from '../_services';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {

    constructor(
      private router: Router,
      private authService: AuthService
    ) { }

    canLoad(route: Route): boolean {
      console.log('window.location.pathname', window.location.pathname);
      if (this.authService.isAuthenticated()) {
        return true;
      }
      this.router.navigate(['/auth'], { queryParams: { returnUrl: window.location.pathname }});
      return false;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      if (this.authService.isAuthenticated()) {
        return true;
      }
      this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url }});
      return false;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      return this.canActivate(childRoute, state);
    }
}

